/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const CurrentUser_Shared_Query = gql`
  query CurrentUser_Shared_Query {
    currentUser {
      id
      systemGeneratedPassword
      hasMultipleStorePlatforms
    }
  }
`;

export { CurrentUser_Shared_Query };
